module.exports = __webpack_public_path__ + "img/alfie-w6.0ac96f76.jpeg";